import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { SpinnerGap } from '@phosphor-icons/react';

const statusColors = {
  NEW: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  OPEN: 'bg-blue-50 text-blue-700 border-blue-200',
  IN_PROGRESS: 'bg-amber-50 text-amber-700 border-amber-200',
  OPPORTUNITY: 'bg-violet-50 text-violet-700 border-violet-200',
  CLIENT: 'bg-green-50 text-green-700 border-green-200',
  QUALIFIED: 'bg-teal-50 text-teal-700 border-teal-200',
  UNQUALIFIED: 'bg-red-50 text-red-700 border-red-200',
  DUPLICATED: 'bg-gray-50 text-gray-500 border-gray-200',
  INVALID: 'bg-red-50 text-red-600 border-red-200',
  OPEN_DEAL: 'bg-indigo-50 text-indigo-700 border-indigo-200',
};

export default function ContactsPage() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.post('/contactos/marketing/list')
      .then(r => { setContacts(r.data?.data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><SpinnerGap size={28} className="animate-spin text-[#0F1829]" /></div>;

  return (
    <div data-testid="contacts-page" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <div className="mb-6">
        <h1 className="text-2xl font-bold tracking-tight text-[#111827]" style={{ fontFamily: "'Fraunces', sans-serif" }}>Contactos</h1>
        <p className="text-sm text-[#6B7280] mt-1">{contacts.length} contactos registados</p>
      </div>

      <div className="bg-white border border-[#E5E7EB] rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full">
          <thead><tr className="border-b border-[#E5E7EB] bg-[#F9FAFB]">
            <th className="text-left text-[10px] uppercase tracking-[0.2em] font-medium text-[#6B7280] px-4 py-3">Nome</th>
            <th className="text-left text-[10px] uppercase tracking-[0.2em] font-medium text-[#6B7280] px-4 py-3">Email</th>
            <th className="text-left text-[10px] uppercase tracking-[0.2em] font-medium text-[#6B7280] px-4 py-3">Telemóvel</th>
            <th className="text-left text-[10px] uppercase tracking-[0.2em] font-medium text-[#6B7280] px-4 py-3">Estado</th>
            <th className="text-left text-[10px] uppercase tracking-[0.2em] font-medium text-[#6B7280] px-4 py-3">Data Criação</th>
          </tr></thead>
          <tbody>
            {contacts.map(c => (
              <tr key={c.ID_Contacto}
                data-testid={`contact-row-${c.ID_Contacto}`}
                onClick={() => navigate(`/contactos/${c.ID_Contacto}`)}
                className="border-b border-[#F3F4F6] hover:bg-[#F9FAFB] cursor-pointer transition-colors">
                <td className="px-4 py-3 text-sm font-medium text-[#0F1829] underline">{c.Nome}</td>
                <td className="px-4 py-3 text-sm text-[#6B7280]">{c.Email || '-'}</td>
                <td className="px-4 py-3 text-sm text-[#6B7280]">{c.Telemovel || '-'}</td>
                <td className="px-4 py-3">
                  <span className={`text-[9px] uppercase tracking-[0.15em] font-semibold px-1.5 py-0.5 rounded border ${statusColors[c.ID_TipoStatusContacto] || 'bg-gray-50 text-gray-600 border-gray-200'}`}>
                    {c.StatusContacto}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-[#6B7280]">{c.DataCriacao || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        {contacts.length === 0 && <div className="text-center py-8 text-sm text-[#6B7280]">Sem contactos registados</div>}
      </div>
    </div>
  );
}
